// Module
var code = `<!-- APP GENERATOR + CMS DEMO -->
<section class="app-demo" aria-labelledby="app-demo-headline">

    <div class="app-demo__inner">

        <header class="app-demo__header">
            <p class="app-demo__label">Generate the app. Edit it live. Keep the structure intact.</p>
            <p class="app-demo__sub">
                SpyneJS connects application generation and live CMS editing through clear, durable
                boundaries — so what you generate stays yours to extend, maintain, and hand off.
            </p>
        </header>

        <figure class="app-demo__screen">

            <div class="app-demo__screen-bar">
        <span class="app-demo__window-dots" aria-hidden="true">
          <span class="app-demo__dot app-demo__dot--red"></span>
          <span class="app-demo__dot app-demo__dot--yellow"></span>
          <span class="app-demo__dot app-demo__dot--green"></span>
        </span>
                <span class="app-demo__screen-url">localhost:8080 — SpyneJS Application Generator</span>
            </div>

            <div class="app-demo__screen-body">

                <!-- Generated App Preview -->
                <div class="app-demo__app-side">
                    <img
                            src="https://assetscontainer.com/assets/imgs/app-builder-w-cms-min.png"
                            alt="SpyneJS Application Generator showing a generated SPA alongside the live CMS editor — headline, subheadline, CTA fields and page items editable in real time"
                            class="app-demo__screenshot"
                            loading="lazy"
                            decoding="async"
                    >
                    <div class="app-demo__screenshot-fade" aria-hidden="true"></div>
                </div>

            </div>

            <figcaption class="app-demo__screen-footer">
        <span class="app-demo__screen-note">
          Full-featured SPA generated with AI content and design token system —
          editable live through the built-in CMS
        </span>
                <a data-channel="ROUTE"
                   data-event-prevent-default="true"
                   data-page-id="configure"
                   href="/configure"
                   class="app-demo__screen-cta">Try the generator →</a>
            </figcaption>

        </figure>

        <ul class="app-demo__features" aria-label="Application Generator features">
            <li class="app-demo__feature">
                <span class="app-demo__feature-title">Application Generator</span>
                <span class="app-demo__feature-desc">
          Generate a full-featured SPA online with AI-generated content and a design
          token system. The fastest way to see how SpyneJS structures a real application.
        </span>
                <span class="app-demo__feature-tags">
          <span class="app-demo__tag">Online</span>
          <span class="app-demo__tag">AI content</span>
          <span class="app-demo__tag">Design tokens</span>
        </span>
            </li>
            <li class="app-demo__feature">
                <span class="app-demo__feature-title">Live CMS editing</span>
                <span class="app-demo__feature-desc">
          WYSIWYG editing with changes rendering in the application as you make them.
          Combine content from multiple external sources in a single editor view.
        </span>
                <span class="app-demo__feature-tags">
          <span class="app-demo__tag">WYSIWYG</span>
          <span class="app-demo__tag">Multi-source</span>
          <span class="app-demo__tag">Live preview</span>
        </span>
            </li>
            <li class="app-demo__feature">
                <span class="app-demo__feature-title">Copy prompt</span>
                <span class="app-demo__feature-desc">
          Generates a contextual AI prompt for any content section. Paste it into
          Claude, ChatGPT, or your own model — the response already fits the
          section's structure.
        </span>
                <span class="app-demo__feature-tags">
          <span class="app-demo__tag app-demo__tag--ai">AI-assisted</span>
          <span class="app-demo__tag">Any model</span>
        </span>
            </li>
            <li class="app-demo__feature">
                <span class="app-demo__feature-title">Durable boundaries</span>
                <span class="app-demo__feature-desc">
          Clear, structural separation between generated application code and content.
          What you generate stays yours to extend, maintain, and hand off.
        </span>
                <span class="app-demo__feature-tags">
          <span class="app-demo__tag">Structure-first</span>
          <span class="app-demo__tag">Evolvable</span>
        </span>
            </li>
        </ul>

        <div class="app-demo__cta">
            <a  data-channel="ROUTE"
                data-event-prevent-default="true"
                data-page-id="configure"
                href="/configure"
                class="btn btn--primary">Generate my first app</a>
            <a  data-channel="ROUTE"
                data-event-prevent-default="true"
                data-page-id="docs"
                data-stage="examples"
                data-text="Docs"
                href="/docs/examples"
                class="btn btn--secondary">See the docs</a>



        </div>

    </div>

</section>
`;
// Exports
module.exports = code;